var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=%25E5%258A%25B3%25E5%258A%25A1%25E6%25B4%25BE%25E9%2581%25A3%252F%25E4%25BA%25BA%25E5%2591%2598%25E8%25A1%25A8.cpt","id":"mobsf","width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }